<script>
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import ModuleFunction from "@core/components/common/expression-language/ModuleFunction.vue";

export default {
    components: {ModuleFunction, AppCollapse, AppCollapseItem},
    props: {
        module: {
            required: true
        }
    },
    methods: {
        generateName(func) {
            let args = func.arguments.map(arg => {
                return arg.name;
            });

            return this.module.key + '.' + func.name + '(' + args.join(', ') + ')';
        }
    }
}
</script>

<template>
    <div>
        <AppCollapse type="margin" accordion>
            <AppCollapseItem title="d" v-for="func in module.functions">
                <template #header>
                    <div class="d-flex justify-content-between align-items-center w-100">
                        <div><strong>{{ generateName(func) }}</strong></div>
                        <div>{{ func.description }}</div>
                    </div>
                </template>

                <ModuleFunction
                    :module="module"
                    :func="func"
                />
            </AppCollapseItem>
        </AppCollapse>
    </div>
</template>

<style scoped lang="scss">

</style>
